import { render, staticRenderFns } from "./FarmingView.vue?vue&type=template&id=731d5229&scoped=true&"
import script from "./FarmingView.vue?vue&type=script&lang=js&"
export * from "./FarmingView.vue?vue&type=script&lang=js&"
import style0 from "./FarmingView.vue?vue&type=style&index=0&id=731d5229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d5229",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
